module.exports = __webpack_public_path__ + "img/IMG_0635.fb3aebcb.jpeg";